import { OrbitControlCameraTupleMapper } from "./OrbitControlCameraTupleMapper";
import { CameraTuple } from "./CameraTuple";

import { Object3D, Vector3 } from "three";

declare const STAGE: any;

export class CameraTupleHelper {
  cameraMapper: OrbitControlCameraTupleMapper;

  constructor() {
    this.cameraMapper = new OrbitControlCameraTupleMapper();
  }

  fitObject(object: Object3D, directionToCamera: Vector3, extraZoom: number = 1): CameraTuple {
    const c = new CameraTuple();
    STAGE.getCameraVectorsAsZoomTo(object, directionToCamera, extraZoom, c.position, c.target);
    return c;
  }

  fitObjectAzimuth(object: Object3D, azimuth: number, extraZoom: number = 1): CameraTuple {
    const c = this.cameraMapper.getCurrentCamera();
    c.setAzimuth(azimuth);
    STAGE.getCameraVectorsAsZoomTo(
      object,
      c.getDirectionToCamera(),
      extraZoom,
      c.position,
      c.target,
    );
    return c;
  }
}
